import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  customsUpdatedInfoBanner: {
    id: '2j0D2C',
    defaultMessage:
      'Customs requirements have recently been updated. Learn more about <helpLink>customs declarations</helpLink> to ensure your shipments clear customs.',
    description:
      'Banner message to inform users that the customs information has been updated and they need to review and submit their customs declaration.',
  },
});
